<template>
  <v-container fluid>
    <v-card
      class="mx-auto mb-4"
      :loading="loading"
      v-for="(poliza, index) in datosPoliza"
      :key="index"
    >
      <v-card-title>
        <h6>DATOS DE LA PÓLIZA</h6>
      </v-card-title>
      <v-card-text class="text--primary px-8">
        <v-row class="pr-0 mb-1">
          <v-col cols="12" sm="3" md="3">
            <p>
              Fecha Inicio: <b>{{ poliza.fechaIni }}</b>
            </p>
          </v-col>
          <v-col cols="12" sm="3" md="3">
            <p>
              Fecha Fin: <b>{{ poliza.fechaFin }}</b>
            </p>
          </v-col>
          <v-col cols="12" sm="3" md="3" v-if="poliza.empresa">
            <p>
              Empresa: <b>{{ poliza.empresa }}</b>
            </p>
          </v-col>
          <v-col cols="12" sm="3" md="3" v-if="poliza.estado">
            <p>
              Estado: <b>{{ poliza.estado }}</b>
            </p>
          </v-col>
          <v-col cols="12" sm="5" md="5">
            <p>
              Pólizas: <b>{{ poliza.polizas }}</b>
            </p>
          </v-col>
          <v-col cols="12" sm="5" md="5" v-if="poliza.deducible">
            <p>
              Deducible: <b>{{ poliza.deducible }}</b>
            </p>
          </v-col>
          <v-col cols="12" sm="2" md="2" v-if="poliza.ramo">
            <p>
              Ramo: <b>{{ poliza.ramo }}</b>
            </p>
          </v-col>
          <v-col cols="12" sm="12" md="12">
            <p>
              Nombre del producto: <b>{{ poliza.nombre_producto }}</b>
            </p>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import { db } from "../../firebase";

export default {
  name: "ComponentePoliza",
  data() {
    return {
      loading: true,
      datosPoliza: [],
      id: this.$route.params.id,
    };
  },
  props: {
    showPoliza: { type: Boolean, default: false },
  },
  async mounted() {
    await this.getData();
  },
  methods: {
    async getData() {
      try {
        await db
          .collection("polizas")
          .where("idCaso", "in", [this.id])
          .onSnapshot((snap) => {
            const resul = snap.docs.map((e) => e.data());

            // Guardar todos los resultados en this.datosPoliza como array
            this.datosPoliza = resul;

            // Verificar si el array está vacío o si los elementos no tienen `nombre_producto`
            if (
              !this.datosPoliza.length ||
              !this.datosPoliza.some((poliza) => poliza.nombre_producto)
            ) {
              this.$emit("update:showPoliza", !this.showPoliza);
            }

            this.loading = false;
          });
      } catch (error) {
        this.handleError(error);
      }
    },
    handleError({ message }) {
      this.swal({ icon: "error", title: "Oops...", text: message });
      this.loading = false;
    },
  },
};
</script>
<style lang="scss"></style>
